import {
  EnvironmentOutlined,
  FacebookFilled,
  GlobalOutlined,
  InstagramFilled,
  MailOutlined,
  PhoneOutlined,
  TwitterSquareFilled,
  YoutubeFilled,
} from "@ant-design/icons";
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white mt-[20px]">
      <div className="flex justify-center px-4 py-8">
        <div className="flex items-center justify-between w-content">
          <div className="w-full md:w-fit ">
            <img
              className="w-[145px] h-[145px] m-auto"
              src={require("../assets/images/logoPNG.png")}
              alt=""
            />
          </div>
          <div className="flex flex-col md:flex-row">
            <div>
              <div className="flex items-center md:text-[24px] text-xs text-[#222222] font-semibold gap-1 mb-[14px]">
                <EnvironmentOutlined className="md:text-2xl text-[14px] mr-1" />
                LIÊN HỆ VỚI SPHACY
              </div>
              <ul className="text-[#747474] md:text-[16px] text-[10px] flex flex-col gap-[14px] max-w-[400px]">
                <li>
                  Tầng 07, Tòa nhà Ladeco, số 266 Đội Cấn, Phường Liễu Giai,
                  Quận Ba Đình, Hà Nội
                </li>
                <li>
                  Tầng 3, Toà nhà An Phú, 117-119 Lý Chính Thắng, phường Võ Thị
                  Sáu, quận 3, Tp. HCM
                </li>
              </ul>
            </div>

            <div className="mt-4 md:mt-0">
              <div className="flex items-center md:text-[24px] text-xs text-[#222222] font-semibold gap-1 md:mb-[14px] mb-4">
                <PhoneOutlined className="md:text-2xl text-[14px] mr-1" />
                HOTLINE
              </div>
              <ul className="text-[#747474] md:text-[16px] text-[10px] flex flex-col gap-[14px]">
                <li>hotro@sphacy.vn</li>
                <div className="flex gap-4">
                  <li>0909.768.177</li>
                  <li>0812.110.011</li>
                </div>
              </ul>
            </div>
          </div>

          <div className="flex flex-col hidden gap-1 md:block">
            <div className="flex gap-1">
              <a
                target="blank"
                href="https://www.facebook.com/SphacyJointStockCompany"
                className="footer-social w-[45px] h-[45px] flex justify-center items-center"
              >
                <FacebookFilled />
              </a>
              <a
                href="mailto:hotro@sphacy.vn"
                className="footer-social w-[45px] h-[45px] flex justify-center items-center"
              >
                <MailOutlined />
              </a>
            </div>
            <div className="flex gap-1">
              <a
                target="blank"
                href="https://sphacy.com"
                className="footer-social w-[45px] h-[45px] flex justify-center items-center"
              >
                <GlobalOutlined />
              </a>
              <a
                target="blank"
                href="https://www.youtube.com/channel/UCCo2xxiMJqB88QWuAbxaWdQ"
                className="footer-social w-[45px] h-[45px] flex justify-center items-center"
              >
                <YoutubeFilled />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="py-[8px] bg-[#119AE2] text-center text-white">
        &copy; Bản quyền thuộc về Công ty Cổ phần SPHACY
      </div>
    </footer>
  );
}
